// extracted by mini-css-extract-plugin
export default {"main":"AboutUs_main__t2RmT","about-us-container":"AboutUs_about-us-container__gngRr"};